import { __extends } from "tslib";
import { Event } from './Event';
var TimerEvent = /** @class */ (function (_super) {
    __extends(TimerEvent, _super);
    function TimerEvent(type, bubbles, cancelable) {
        return _super.call(this, type, bubbles, cancelable) || this;
    }
    TimerEvent.prototype.clone = function () {
        return new this.sec.flash.events.TimerEvent(this.type, this.bubbles, this.cancelable);
    };
    TimerEvent.prototype.toString = function () {
        return this.formatToString('TimerEvent', 'type', 'bubbles', 'cancelable', 'eventPhase');
    };
    TimerEvent.prototype.updateAfterEvent = function () {
        //release || console.log("TimerEvent.updateAfterEvent not implemented");
        this.sec.player.requestRender();
    };
    TimerEvent.classInitializer = null;
    TimerEvent.classSymbols = null;
    TimerEvent.instanceSymbols = null;
    // JS -> AS Bindings
    TimerEvent.TIMER = 'timer';
    TimerEvent.TIMER_COMPLETE = 'timerComplete';
    return TimerEvent;
}(Event));
export { TimerEvent };
